import React from 'react';
import './ServicePackageSection.css';
import { FaCheckCircle } from 'react-icons/fa'; // Icon for list points

const ServicePackageSection: React.FC = () => (
  <div className="premium-packages-section">
    <h2>Our Premium Packages</h2>
    <div className="packages-container">
      {/* Gold Package */}
      <div className="package-card">
        <h3>Gold Package</h3>
        <ul className="package-list">
          <li><FaCheckCircle className="list-icon" /> High pressure foam wash</li>
          <li><FaCheckCircle className="list-icon" /> Interior and exterior glass cleaned</li>
          <li><FaCheckCircle className="list-icon" /> Interior vacuum</li>
          <li><FaCheckCircle className="list-icon" /> Rims tires dressed</li>
          <li><FaCheckCircle className="list-icon" /> Door jambs cleaned</li>
          <li><FaCheckCircle className="list-icon" /> Interior plastics cleaned</li>
        </ul>
        <div className="package-price-section">
          <div className="package-price">$99</div>
        </div>
      </div>

      {/* Platinum Package */}
      <div className="package-card">
        <h3>Platinum Package</h3>
        <ul className="package-list">
          <li><FaCheckCircle className="list-icon" /> High pressure foam wash</li>
          <li><FaCheckCircle className="list-icon" /> Interior vacuum</li>
          <li><FaCheckCircle className="list-icon" /> Windows treated with wax</li>
          <li><FaCheckCircle className="list-icon" /> Interior plastics cleaned with UV protection</li>
          <li><FaCheckCircle className="list-icon" /> Exterior plastic restored</li>
          <li><FaCheckCircle className="list-icon" /> Rims tyres dressed</li>
          <li><FaCheckCircle className="list-icon" /> Fabric/leather seat and carpet shampooed and conditioned treatment with steam</li>
        </ul>
        <div className="package-price-section">
          <div className="package-price">$199</div>
        </div>
      </div>

      {/* Pre-Sale Car Detailing Package */}
      <div className="package-card">
        <h3>Pre-Sale Car Detailing Package</h3>
        <ul className="package-list">
          <li><FaCheckCircle className="list-icon" /> Ph foam wash</li>
          <li><FaCheckCircle className="list-icon" /> Wheel cleaning</li>
          <li><FaCheckCircle className="list-icon" /> Tyres cleaning</li>
          <li><FaCheckCircle className="list-icon" /> Bug Tar Iron removal</li>
          <li><FaCheckCircle className="list-icon" /> Window cleaning</li>
          <li><FaCheckCircle className="list-icon" /> Steam cleaning seat carpet, pillar trims, dash and centre console</li>
          <li><FaCheckCircle className="list-icon" /> Vaccume seats, carpet and floor</li>
          <li><FaCheckCircle className="list-icon" /> Shampoo seats and carpet</li>
          <li><FaCheckCircle className="list-icon" /> Interior trim components restored and protected</li>
          <li><FaCheckCircle className="list-icon" /> Engine bay surface detail</li>
          <li><FaCheckCircle className="list-icon" /> Tyre dressing</li>
          <li><FaCheckCircle className="list-icon" /> Apply interior wax</li>
          <li><FaCheckCircle className="list-icon" /> Apply exterior wax</li>
        </ul>
        <h4>Add Extra</h4>
        <ul className="package-list">
          <li><FaCheckCircle className="list-icon" /> Single Stage Pain Correction from $299</li>
        </ul>
        <div className="package-price-section">
          <div className="package-price">$299</div>
          <h6>(For a Small Car)</h6>
        </div>
      </div>
    </div>
  </div>
);

export default ServicePackageSection;
